import { useState } from "react";

export function useOnChange(dep: unknown, callback: () => void) {
	const [prevDep, setPrevDep] = useState(dep);
	if (prevDep !== dep) {
		callback();
		setPrevDep(dep);
	}
}